export default {"src":"/_next/static/media/bw.64503f0a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};